/* Darkroom — add-to-bag shutter fire.
   Design ref: technical/design/nelson-film-co/project/v2-darkroom.jsx (V2AddToBag)
   Intercepts the native product-form POST (which navigates to /cart) and adds
   via fetch instead, so the customer stays on the page. Feedback is the
   shutter-fire state on the CTA: blackout blink → yellow "✓ Added" → revert
   to "↳ Add to bag" after ~1.1s. Repeat clicks restart the hold and add again.
   The bag drawer (Fizzy #232) will become the primary confirmation when built;
   this stays as the button-local layer. */

(function () {
  var HOLD_MS = 1100;

  function ctasFor(form) {
    var inside = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"]'));
    var outside = form.id
      ? Array.prototype.slice.call(document.querySelectorAll('button[form="' + form.id + '"]'))
      : [];
    return inside.concat(outside);
  }

  function labelSpan(button) {
    return button.querySelector('span');
  }

  function setAdded(buttons, on) {
    buttons.forEach(function (b) {
      var span = labelSpan(b);
      if (span && !b.dataset.atbLabel) b.dataset.atbLabel = span.textContent;
      b.classList.toggle('dk-cta--added', on);
      if (span) span.textContent = on ? '✓ Added' : b.dataset.atbLabel;
    });
  }

  function errorEl(form) {
    var el = form.querySelector('.dk-atb-error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'dk-atb-error';
      el.setAttribute('role', 'alert');
      form.appendChild(el);
    }
    return el;
  }

  function updateBagCount() {
    var count = document.getElementById('dk-bag-count');
    if (!count) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { count.textContent = '[' + cart.item_count + ']'; })
      .catch(function () {});
  }

  function wire(form) {
    var timer = null;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var buttons = ctasFor(form);
      errorEl(form).textContent = '';

      // Optimistic fire — the blackout blink doubles as the latency mask.
      // Restarting the class re-triggers the animation on repeat clicks.
      buttons.forEach(function (b) { b.classList.remove('dk-cta--added'); });
      void form.offsetWidth;
      setAdded(buttons, true);
      clearTimeout(timer);
      timer = setTimeout(function () { setAdded(buttons, false); }, HOLD_MS);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) {
              clearTimeout(timer);
              setAdded(buttons, false);
              errorEl(form).textContent =
                data.description || data.message || 'Could not add to bag — please try again.';
              return;
            }
            updateBagCount();
          });
        })
        .catch(function () {
          clearTimeout(timer);
          setAdded(buttons, false);
          errorEl(form).textContent = 'Could not add to bag — please try again.';
        });
    });
  }

  function init() {
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
